export default __webpack_public_path__ + "static/media/Prevent account takeovers.c9bac93e.svg";